import Close from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { NormalButton } from 'components/atoms/Button';
import React, { SetStateAction } from 'react';

interface IImagePreview {
  url?: string;
  setMedia: SetStateAction<any>;
  sendMessage: (e: any) => void;
  e: any;
}

const ImagePreview = ({ url, setMedia, sendMessage, e }: IImagePreview) => {
  return (
    <div className="preview-container">
      <IconButton
        sx={{
          padding: '5px',
          borderRadius: '50%',
          backgroundColor: 'white',
          position: 'absolute',
          right: '15px',
          top: '15px',
          zIndex: '99',
        }}
        onClick={() => setMedia(undefined)}
      >
        <Close sx={{ color: 'black' }} />
      </IconButton>
      <NormalButton
        text="Send"
        color="yellow"
        sx={{
          position: 'absolute',
          bottom: '10px',
          right: '10px',
          padding: '8px 16px',
          zIndex: '99',
        }}
        onClick={() => sendMessage(e)}
      />
      <video poster={url} src={url} />
    </div>
  );
};

export default ImagePreview;
